import { render, staticRenderFns } from "./ReportsDistributor.vue?vue&type=template&id=7bec36e8&"
import script from "./ReportsDistributor.vue?vue&type=script&lang=js&"
export * from "./ReportsDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports